<template>
    <section class="section section-products">
        <div class="head-section">
            <p>Todos los productos</p>
            <p>{{ allPruducts.length }} resultados</p>
        </div>
        <div class="content-section">
            <aside class="filter">
                <div class="filter-category">
                    <h4>Categorias</h4>
                    <div class="options options-category">
                        <details v-for="category in categories" :key="category.id" class="subcategories">
                            <summary>
                                <input type="checkbox" name="category" id="" :value="category.id" @click="(e) => filterCategory(e)" :checked="searchURL.includes(category.id)">
                                <label for=""> {{ category.name }}</label>
                            </summary>
                            <div v-for="subcategory in category.subcategories" :key="subcategory.id">
                                <input type="checkbox" name="subcategory" id="" :value="subcategory.id" @click="(e) => filterSubCategory(e)" :checked="searchURL.includes(category.id)">
                                <label for=""> {{ subcategory.name }}</label>
                            </div>
                        </details>
                    </div>
                </div>
                <div class="filter-brand">
                    <h4>Marcas</h4>
                    <div class="options options-brand">
                        <div v-for="brand in brands" :key="brand.nameBrand" class="option-brand">
                            <input type="checkbox" name="subcategory" id="" :value="brand.nameBrand" @click="(e) => filterBrand(e)">
                            <label for="">{{ brand.nameBrand }}</label>
                        </div>
                    </div>
                </div>
            </aside>
            <aside class="list list-products">
                <CardProduct v-for="product in allPruducts" :key="product.id" :product="product" />   
            </aside>
        </div>
        <MoreInfoProductsComponent />
    </section>
</template>

<script setup>
import categories from "@/data/categories.json";
import brands from "@/data/brands.json";
import products from "@/data/products.json";
import { ref, onMounted } from "vue";

import CardProduct from "@/components/Card/CardProduct.component.vue";
import MoreInfoProductsComponent from "./components/MoreInfoProducts.component.vue";

let allPruducts = ref(products);
let searchURL = ref(location.search);

let selectedFilterGeneral = ref({
    categories: [],
    brands: []
})
onMounted(() => {
    // Inicializar los filtros si es necesario
    selectedFilterGeneral.value.categories = [];
    selectedFilterGeneral.value.brands = [];

    searchURL.value = location.search;

    if(location.search.includes('categories=')) {
        let categoriesFromUrl = location.search.replace('?categories=', '').split(',');
        selectedFilterGeneral.value.categories = categoriesFromUrl;

        let noseUno = []
        let noseDos = []
        products.filter((item) => {

            if(selectedFilterGeneral.value.categories.includes(item.id_category_product)) {
                if(selectedFilterGeneral.value.brands.includes(item.brand_product)) {
                    noseUno.push(item);
                }
                noseDos.push(item)
            }
        })

        if(selectedFilterGeneral.value.brands.length > 0 && noseUno.length == 0) {
            allPruducts.value = noseUno;
            return;
        }
        else {
            allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
        }
    }
    else {
        allPruducts.value = products;
    }
});

function filterCategory(e) {

    let valueCategory = e.target.value;
    if(e.target.checked == true) {
        selectedFilterGeneral.value.categories.push(valueCategory);
        
        let noseUno = []
        let noseDos = []
        products.filter((item) => {

            if(selectedFilterGeneral.value.categories.includes(item.id_category_product)) {
                if(selectedFilterGeneral.value.brands.includes(item.brand_product)) {
                    noseUno.push(item);
                }
                noseDos.push(item)
            }
        })
        console.log('noseUno', noseUno);
        console.log('noseDos', noseDos);

        if(selectedFilterGeneral.value.brands.length > 0 && noseUno.length == 0) {
            allPruducts.value = noseUno;
            return;
        }
        else {
            allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
        }

    }else if(e.target.checked == false) {
        
        // SI EL ARRAY DE CATEGORIAS ESTA A PUNTO DE QUEDAR VACIO
        if(selectedFilterGeneral.value.categories.length == 1) {
            selectedFilterGeneral.value.categories = [];

            let noseUno = []
            let noseDos = []
            products.filter((item) => {
                if(selectedFilterGeneral.value.brands.includes(item.brand_product)) {
                    noseUno.push(item);
                }
                noseDos.push(item);
            })
            allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
            return;
        }

        selectedFilterGeneral.value.categories = selectedFilterGeneral.value.categories.filter((item) => {
            return item != valueCategory
        })

        let noseUno = []
        let noseDos = []
        products.filter((item) => {
            if(selectedFilterGeneral.value.categories.includes(item.id_category_product)) {
                if(selectedFilterGeneral.value.brands.includes(item.brand_product)) {
                    noseUno.push(item);
                }                    
                noseDos.push(item);
            }
        })
        allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
        
        

    }

    
}
function filterSubCategory(e) {
    console.log('filter sub category', e.target.value)
}
function filterBrand(e) {
    let valueBrand = e.target.value;
    if(e.target.checked == true) {
        selectedFilterGeneral.value.brands.push(valueBrand);

        let noseUno = []
        let noseDos = []
        products.filter((item) => {
            if(selectedFilterGeneral.value.brands.includes(item.brand_product)) {
                if(selectedFilterGeneral.value.categories.includes(item.id_category_product)) {
                    noseUno.push(item);
                }
                noseDos.push(item);
            }
        })

        if(selectedFilterGeneral.value.categories.length > 0 && noseUno.length == 0) {
            allPruducts.value = noseUno;
            return;
        }
        else {
            allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
        }

    }else if(e.target.checked == false) {

        // SI EL ARRAY DE MARCAS ESTA A PUNTO DE QUEDAR VACIO
        if(selectedFilterGeneral.value.brands.length == 1) {
            selectedFilterGeneral.value.brands = [];

            let noseUno = []
            let noseDos = []
            products.filter((item) => {
                if(selectedFilterGeneral.value.categories.includes(item.id_category_product)) {
                    noseUno.push(item);
                }
                noseDos.push(item);
            })
            allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
            return;
        }

        selectedFilterGeneral.value.brands = selectedFilterGeneral.value.brands.filter((item) => {
            return item != valueBrand
        })

        let noseUno = []
        let noseDos = []
        products.filter((item) => {
            if(selectedFilterGeneral.value.brands.includes(item.brand_product)) {
                if(selectedFilterGeneral.value.categories.includes(item.id_category_product)) {
                    noseUno.push(item);
                }                    
                noseDos.push(item);
            }
        })
        allPruducts.value = noseUno.length > 0 ? noseUno : noseDos;
    }
    
}

</script>

<style lang="scss" scoped>  
.section-products {
    margin-inline: 300px;
    .head-section {
        text-align: start;
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .content-section {
        display: flex;
        flex-direction: row;
        gap: 40px;
        .filter {
            width: 300px;
            h4 {
                font-weight: 700;
                text-align: start;
            }
            .filter-category, .filter-brand {
                display: flex;
                flex-direction: column;
                gap: 15px;
            }
            .filter-brand {
                margin-top: 30px;
            }
            .options-category {
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: start;
                height: 300px;
                overflow: scroll;
            }
            .options-category details{
                width: 100%;
                text-align: start;
            }
            .options-brand {
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: start;
                height: 300px;
                overflow: scroll;
            }
        }
        .list-products {
            width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
        gap: 10px;
        }
    }
}

@media (max-width: 1600px) {
    .section-products {
        margin-inline: 100px;
    }
}
@media (max-width: 1080px) {
    .section-products {
        margin-inline: 80px;
        .content-section {
            gap: 20px;
            .list-products {
                width: 100%;
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 10px;
            }
        }
    }
}
@media (max-width: 580px) {
    .section-products {
        margin-inline: 20px;
    }
}

@media (max-width: 400px) {
    .section-products {
        .content-section {
            display: flex;
            flex-direction: column;
            .filter {
                width: 100%;
            }
            .filter .filter-category {
                display: none;
            }
            .filter .filter-brand .options-brand {
                display: flex;
                flex-direction: row;
                gap: 25px;
                height: auto;
                .option-brand {
                    display: flex;
                    flex-direction: row;
                    gap: 5px;
                }
            }
        }
    }
}
</style>